import { Check } from "@mui/icons-material"
import { Button, Card, CardContent, Divider } from "@mui/material"
import moment from "moment"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import FormAutocomplete from "../../../../shared/FormAutocomplete"
import FormDate from "../../../../shared/FormDate"
import FormNumber from "../../../../shared/FormNumber"
import FormText from "../../../../shared/FormText"
import notificationError from "../../../../shared/notificationError"
import notificationSuccess from "../../../../shared/notificationSuccess"
import { editOvertime } from "../overtime.api"
import { OvertimeApprovelAnalyze } from "./OvertimeApprovelAnalyze"

export default function OvertimeApprovalHr(props: any) {

    const dispatch = useDispatch()

    const [values, setValues] = useState<any>({
        id: "",
        minutes_approval: "",
        multiple: "",
        hr_status_id: ""
    })

    useEffect(() => {
        setValues({
            id: props.data.id,
            minutes_approval: props.data.minutes_approval,
            multiple: props.data.multiple,
            hr_status_id: props.data.hr_status_id
        })
    }, [])

    const handleChangeValues = (e: any) => {
        const { name, value } = e.target
        setValues({
            ...values,
            [name]: value
        })
    }

    const handleSubmit = (e: any) => {
        e.preventDefault()
        dispatch<any>(editOvertime(values))
            .unwrap()
            .then((response: any) => {
                if (response.status === 200) {
                    notificationSuccess("success edit overtime")
                        .then(() => {
                            props.onClose(true)
                        })
                }
                else {
                    notificationError(response)
                }
            })
    }

    return (
        <Card>
            <CardContent className="custom-form">
                {props.data.job_list && <OvertimeApprovelAnalyze jobList={JSON.parse(props.data.job_list)} requestMinute={values.minutes} />}
                <form onSubmit={handleSubmit}>
                    <Divider />
                    <br />
                    {values.id && <FormDate label="Overtime Date" name="name" value={moment(props.data.name).format("YYYY-MM-DD")} disabled />}
                    <br />
                    <Divider />
                    <br />
                    {values.id && <FormNumber label="Request Minutes" name="minutes" value={props.data.minutes} disabled />}
                    <br />
                    <Divider />
                    <br />
                    {values.id && <FormText label="Notes" name="notes" value={props.data.notes} disabled />}
                    <br />
                    <Divider />
                    <br />
                    <FormNumber label="Approved Minutes" name="minutes_approval" value={values.minutes_approval} onChange={handleChangeValues} />
                    <br />
                    <Divider />
                    <br />
                    <FormNumber label="Multiple" name="multiple" value={values.multiple} onChange={handleChangeValues} step={0.5} />
                    <br />
                    <Divider />
                    <br />
                    {values.id && <FormAutocomplete url="/status/approval" label="Status Head" name="head_status_id" value={props.data.head_status_id} disabled />}
                    <br />
                    <Divider />
                    <br />
                    {values.id && <FormAutocomplete url="/status/approval" label="Status HR" name="hr_status_id" value={values.hr_status_id} onChange={handleChangeValues} />}
                    <br />
                    <Divider />
                    <br />
                    <div className="form-footer">
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => props.onClose(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<Check />}
                            type="submit"
                        >
                            Update Overtime
                        </Button>
                    </div>
                </form>
            </CardContent>
        </Card >
    )
}